import React from "react";

const Icon = ({ i, style }: { i: string, style?: React.CSSProperties }) => <span className={`i-${i}`} style={style} />;

export default Icon;
